<template>
    <div class="common-map-wrap" v-if="isShowBdMap">
        <ev-importFile :href="apiUrl" v-if="mapCenter"></ev-importFile>

        <div :id="mapId" style="width: 100%; height: 100%; z-index: 1;"></div>

        <slot :instance="getMapInstance()" :BMap="MapAPI" :Heatmap="Heatmap" :bounds="mapBounds" :is3D="is3D"></slot>

        <ul class="mode-wrap animated fadeInRightBig" v-if="modeSwitch">
            <li v-for="(item, index) in mapTypeList" :key="index" :class="{ 'active': mapType === item.type }" @click="handleSwitchMapType(item.type)">{{ item.label }}</li>
        </ul>
    </div>
<!--    <bm-map class="common-map-wrap" v-if="isShowBdMap" :mapClick="false" scrollWheelZoom :center="bdMapMarkerPoint" :zoom="18.07" @ready="bdMapReadyHandler" v-bind="$attrs">-->
<!--        <slot :instance="instance" :BMap="BMap" :Heatmap="Heatmap" :bounds="mapBounds"></slot>-->

<!--        <ul class="mode-wrap animated fadeInRightBig" v-if="modeSwitch">-->
<!--            <li v-for="(item, index) in mapTypeList" :key="index" :class="{ 'active': mapType === item.type }" @click="handleSwitchMapType(item.type)">{{ item.label }}</li>-->
<!--        </ul>-->
<!--    </bm-map>-->
</template>

<script>
    const MapInstanceCache = {};

    import { BaiduMap } from 'vue-baidu-map/components';
    import Heatmap from 'bmaplib.heatmap';
    import Drawing from './support/drawing';

    export default JBoot({
        registryName: 'common-map',

        components: {
            [BaiduMap.name]: BaiduMap
        },

        mixins: [ Drawing ],

        props: {
            type: {
                type: String,
                default (){
                    return '2d'
                }
            },
            mapCenter: {
                required: true,
                type: Object,
                default (){
                    return {};
                }
            },

            modeSwitch: Boolean,

            mapMode: String,

            mapZoom: {
                type: Number,
                default (){
                    return 15
                }
            },

            mapTilt: {
                type: Number,
                default (){
                    return 60;
                }
            },

            mapHeading: {
                type: Number,
                default (){
                    return 0;
                }
            }
        },

        provide (){
            return {
                commonMapInstance: this
            };
        },

        data() {
            return {
                MapAPI: undefined,
                mapType: undefined,
                mapIsReady: false,
                Heatmap
            }
        },

        computed: {
            mapId (){
                return 'common-map-' + Date.now();
            },

            is3D (){
                return this.type && this.type.toLowerCase() === '3d';
            },

            apiUrl (){
                let url = 'https://api.map.baidu.com/api?v=2.0&ak=vwN8EK7HkDfecosEEuc63s09Qnn0W9dj';

                if(this.is3D){
                    url += '&type=webgl';
                }

                return url + '&callback=_handleInitBMap';
            },

            mapTypeList (){
                return this.is3D ? [
                    { label: '卫星地图', type: 'B_EARTH_MAP' },
                    { label: '普通地图', type: 'B_STREET_MAP' },
                ] : [
                    { label: '卫星地图', type: 'BMAP_HYBRID_MAP' },
                    { label: '普通地图', type: 'BMAP_NORMAL_MAP' },
                ]
            },

            defaultMapType (){
                return this.mapMode || (this.is3D ? 'B_EARTH_MAP' : 'BMAP_HYBRID_MAP');
            },


            bdMapMarkerPoint (){
                return { lat: this.mapCenter.lat, lng: this.mapCenter.lng }
            },

            isShowBdMap (){
                return !!this.mapCenter.lng && !!this.mapCenter.lat;
            },

            mapBounds (){
                if(!this.mapInstance || !this.mapIsReady){
                    return {};
                }

                let bounds = this.mapInstance.getBounds(),
                    southWest = bounds.getSouthWest(),
                    northEast = bounds.getNorthEast();

                if(!southWest || !northEast){
                    return {};
                }

                return {
                    xnLat: southWest.lat, //x
                    xnLng: southWest.lng, //y
                    dbLat: northEast.lat, //x
                    dbLng: northEast.lng //y
                }
            }
        },

        created (){
            window._handleInitBMap = this.handleBMapFinished.bind(this);
        },

        beforeDestroy (){
            let instance = this.getMapInstance();
            instance && instance.destroy && instance.destroy();

            // window[this.is3D ? 'BMapGL' : 'BMap'] = undefined;

            delete MapInstanceCache[this.mapId];

            console.log('剩余实例：', MapInstanceCache);
        },

        methods: {
            getMapInstance (){
                return MapInstanceCache[this.mapId];
            },

            handleBMapFinished (){
                window._handleInitBMap = undefined;

                this.MapAPI = window[this.is3D ? 'BMapGL' : 'BMap'];

                console.log(this.MapAPI);

                this.geocoderInstance = new this.MapAPI.Geocoder();

                if(!this.MapAPI) return this.$error('百度地图API加载失败！');

                MapInstanceCache[this.mapId] = new this.MapAPI.Map(this.mapId, {});

                this.handleMapReady = this.bdMapReadyHandler.bind(this);

                this.handleSwitchMapType(this.defaultMapType);

                const instance = this.getMapInstance();

                instance.addEventListener('tilesloaded', this.handleMapReady);

                instance.enableScrollWheelZoom(true);

                instance.enableContinuousZoom(true);

                instance.enableInertialDragging(true);

                if(this.is3D){
                    instance.centerAndZoom(new this.MapAPI.Point(parseFloat(this.mapCenter.lng) * .2, parseFloat(this.mapCenter.lat) * .2), 0);

                    instance.setTilt(this.mapTilt);

                    instance.setHeading(this.mapHeading);
                }else{
                    instance.centerAndZoom(new this.MapAPI.Point(this.mapCenter.lng, this.mapCenter.lat), this.mapZoom);

                    this.setCenterAndZoom = ({ lat, lng } = {}, zoom = 15) => {
                        console.log('changeCenter');

                        instance.centerAndZoom(new this.MapAPI.Point(lng, lat), zoom);
                        // this.getMapInstance().centerAndZoom();
                        // instance.setZoom(18);
                        // this.getMapInstance().setZoom(zoom);
                        // this.getMapInstance().centerAndZoom(new this.MapAPI.Point(lng, lat), zoom);
                    };
                }
            },

            bdMapReadyHandler (){
                this.mapIsReady = true;

                this.getMapInstance().removeEventListener('tilesloaded', this.handleMapReady);

                console.log('baidu map is ready!', this.getMapInstance());

                this.$busBroadcast('map.bd.ready', { instance: this.getMapInstance(), BMap: this.MapAPI, is3D: this.is3D, bounds: this.mapBounds });

                this.$emit('ready', { instance: this.getMapInstance(), BMap: this.MapAPI, is3D: this.is3D, bounds: this.mapBounds });

                this.$nextTick(function () {
                    this.getMapInstance().centerAndZoom(new this.MapAPI.Point(this.mapCenter.lng, this.mapCenter.lat), this.mapZoom);

                    // this.getMapInstance().addOverlay(new this.MapAPI.Marker(new this.MapAPI.Point(this.mapCenter.lng, this.mapCenter.lat)));

                    this.getMapInstance().addEventListener('zoomend', () => {
                        this.$busBroadcast('map.bd.zoom.end');
                    });

                    this.getMapInstance().addEventListener('dragend', event => {
                        this.$busBroadcast('map.bd.dragend', event);

                        this.$emit('dragend', event);
                    });

                    this.getMapInstance().addEventListener('moveend', event => {
                        this.$nextTick(function () {
                            let newEvent = Object.assign({}, event, {point: this.getMapInstance().getCenter()});

                            this.$busBroadcast('map.bd.moveend', newEvent);

                            this.$emit('moveend', newEvent);
                        });
                    });
                });
            },

            handleSwitchMapType (mapType){
                this.mapType = mapType;

                mapType && this.getMapInstance().setMapType(this.is3D ? mapType : window[mapType]);
            },

            getLocationInfo (point){
                return new Promise(resolve => {
                    if(!this.geocoderInstance){
                        return this.$warn('位置获取未准备就绪！');
                    }

                    this.geocoderInstance.getLocation(point, function(rs){
                        resolve(rs);
                        // console.log(rs.address); //地址描述(string)
                        //
                        // console.log(rs.addressComponents);//结构化的地址描述(object)
                        // console.log(rs.addressComponents.province); //省
                        // console.log(rs.addressComponents.city); //城市
                        // console.log(rs.addressComponents.district); //区县
                        // console.log(rs.addressComponents.street); //街道
                        // console.log(rs.addressComponents.streetNumber); //门牌号
                        //
                        // console.log(rs.surroundingPois); //附近的POI点(array)
                        //
                        // console.log(rs.business); //商圈字段，代表此点所属的商圈(string)
                    });
                });
            }
        },

        watch: {}
    }).build();
</script>

<style lang="scss">
    .common-map-wrap{
        height: 100%;
        width: 100%;
        position: relative;
        & .anchorBL{
            display: none;
        }
        & .mode-wrap{
            z-index: 2;
            position: absolute;
            right: 10px;
            bottom: 10px;
            background-color: rgba(0, 0, 0, .7);
            border-radius: 4px;
            overflow: hidden;
            & > li{
                color: #ffffff;
                font-size: 14px;
                display: inline-block;
                cursor: pointer;
                position: relative;
                padding: 2px 8px;
                &.active{
                    background-color: #2d8cf0;
                }
            }
        }

        & .tool-bar-block{
            box-shadow: 0 1px 5px rgba(0,0,0,0.65);
            border-radius: 4px;
            background-color: #ffffff;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/map/Map.vue